import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFr = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-fr",
	viewBox: "0 0 640 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h640v480H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#002654",
			d: "M0 0h213.3v480H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ce1126",
			d: "M426.7 0H640v480H426.7z"
		})
	]
});
export default SvgFr;
